import angular from 'angular'

import investorReportsComponent from './investorReports.component'
import InvestorReportService from './investorReport.service'

export default angular.module('app.pages.investors.investorDashboard.investorReports', [])
  .directive('investorReports', investorReportsComponent)
  .service('investorReportService', InvestorReportService)
